/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_What_P3Inputs */

const en_fc_home_what_p3 = /** @type {(inputs: Fc_Home_What_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft is not a copy of Premiere. It is a clean-room implementation built from public specifications, with its own native decoders for H.264, HEVC, ProRes, VP9, AV1, AAC and Opus. There is no FFmpeg dependency, and time is stored as integers, so 23.976 and 29.97 drop-frame timelines stay frame-accurate.`)
};

/**
* | output |
* | --- |
* | "FilmCraft is not a copy of Premiere. It is a clean-room implementation built from public specifications, with its own native decoders for H.264, HEVC, ProRes..." |
*
* @param {Fc_Home_What_P3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_what_p3 = /** @type {((inputs?: Fc_Home_What_P3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_What_P3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_what_p3(inputs)
});
export { fc_home_what_p3 as "fc.home.what.p3" }